import React, { useState } from 'react'
import styled from 'styled-components'
import { UI_HEADLINE_SM, SANS_3, colors2 as colors } from 'oolib'
import NumberRangeSlider from '@/components/inputs/NumberRangeSlider'

const Container = styled.div`
  padding: 40px;
  max-width: 600px;
  margin: 0 auto;
`

const Section = styled.div`
  margin-bottom: 40px;
  padding: 24px;
  background: ${colors.white};
  border: 1px solid ${colors.grey10};
  border-radius: 8px;
`

const ValueDisplay = styled.div`
  margin-top: 16px;
  padding: 12px;
  background: ${colors.grey5};
  border-radius: 4px;
  font-family: monospace;
`

export const NumberRangeSliderTest = () => {
  const [value1, setValue1] = useState({ min: 20, max: 80 })
  const [value2, setValue2] = useState({ min: 0, max: 500 })
  const [value3, setValue3] = useState({ min: 0, max: 100 })

  return (
    <Container>
      <UI_HEADLINE_SM style={{ marginBottom: 32 }}>NumberRangeSlider Test</UI_HEADLINE_SM>

      <Section>
        <SANS_3 style={{ marginBottom: 16 }}>Basic (0-100, step 1)</SANS_3>
        <NumberRangeSlider
          id="basic"
          value={value1}
          onChange={(id, val) => setValue1(val)}
          min={0}
          max={100}
          step={1}
        />
        <ValueDisplay>
          value: {JSON.stringify(value1)}
        </ValueDisplay>
      </Section>

      <Section>
        <SANS_3 style={{ marginBottom: 16 }}>Large Range (0-1000, step 50)</SANS_3>
        <NumberRangeSlider
          id="large"
          value={value2}
          onChange={(id, val) => setValue2(val)}
          min={0}
          max={1000}
          step={50}
        />
        <ValueDisplay>
          value: {JSON.stringify(value2)}
        </ValueDisplay>
      </Section>

      <Section>
        <SANS_3 style={{ marginBottom: 16 }}>Without Inputs (showInputs=false)</SANS_3>
        <NumberRangeSlider
          id="noinputs"
          value={value3}
          onChange={(id, val) => setValue3(val)}
          min={0}
          max={100}
          showInputs={false}
        />
        <ValueDisplay>
          value: {JSON.stringify(value3)}
        </ValueDisplay>
      </Section>
    </Container>
  )
}
